import script from "./ProposalCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProposalCard.vue?vue&type=script&lang=ts&setup=true"

import "./ProposalCard.vue?vue&type=style&index=0&id=67c7cf5f&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67c7cf5f"]])

export default __exports__